import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-icon-sidebar-mode-list',
    templateUrl: './icon-sidebar-mode-list.component.svg',
    styleUrls: ['../icon-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class IconSidebarModeListComponent { }
